import { throttle } from 'lodash';
import { addEventListener } from 'common/js/media_query_event_polyfill';

class StickyNav {
  constructor() {
    // Sticky setting
    this.stickyEnabled = document.querySelector('[data-sticky-enabled]');

    // Elements
    this.header = document.querySelector('[data-header]');
    this.stickyHeaderPadding = document.querySelector(
      '[data-sticky-header-padding]'
    );
    this.headerTop = document.querySelector('[data-header-top]');
    this.productBookBox = document.querySelector('[data-product-book-box]');

    // Height settings
    this.headerTopHeight = this.headerTop.offsetHeight;
    this.headerScrollShrinkOffset = 100;
    this.mediaMinHeight = 800;

    // Media query
    this.mql = window.matchMedia(`(min-height: ${this.mediaMinHeight}px)`);

    // Init
    if (this.stickyEnabled) {
      this.init();
      this.scrollListener();
      this.resizeListener();
    }
  }

  init() {
    if (this.mql.matches) {
      this.checkScrollPosition();
      this.productBookBoxOffset();
    }
  }

  navStickyEnabled() {
    this.header.classList.add('header--sticky');
    if (this.stickyHeaderPadding) {
      this.stickyHeaderPadding.style.paddingTop = `${this.headerTopHeight}px`;
    }
    this.productBookBoxOffset();
  }

  navStickyDisabled() {
    this.header.classList.remove('header--sticky');
    if (this.stickyHeaderPadding) {
      this.stickyHeaderPadding.style.paddingTop = '0px';
    }
    this.productBookBoxReset();
  }

  shrinkNav() {
    if (window.scrollY > this.headerTopHeight + this.headerScrollShrinkOffset) {
      this.header.classList.add('header--shrink');
    } else if (window.scrollY < this.headerTopHeight) {
      this.header.classList.remove('header--shrink');
    }
  }

  checkScrollPosition() {
    if (this.mql.matches) {
      this.shrinkNav();
      if (window.scrollY > this.headerTopHeight) {
        this.navStickyEnabled();
      } else {
        this.navStickyDisabled();
      }
    }
  }

  scrollListener() {
    window.addEventListener(
      'scroll',
      throttle(() => {
        this.checkScrollPosition();
      }, 100)
    );
  }

  resizeListener() {
    addEventListener(this.mql, (e) => {
      if (e.matches) {
        this.checkScrollPosition();
      } else {
        this.navStickyDisabled();
      }
    });
  }

  productBookBoxOffset() {
    if (this.productBookBox) {
      this.productBookBox.classList.add('product__book-box--nav-offset');
    }
  }

  productBookBoxReset() {
    if (this.productBookBox) {
      this.productBookBox.classList.remove('product__book-box--nav-offset');
    }
  }
}

// Initialise here
document.addEventListener('DOMContentLoaded', () => new StickyNav());
